import { useI18n } from 'vue-i18n';
import { mapState } from 'vuex';

import { buildAccessDeniedLocation } from '@/utilities/accessDeniedLocation.js';

export default {
    computed: {
        ...mapState('Auth', { user: state => state.user }),
    },

    setup() {
        const { t: translate } = useI18n();
        return { translate };
    },

    methods: {
        hasGroupPermissions(permission) {
            return this.user.hasGroupPermissionTo(permission);
        },

        userHasAccessToQuizAdminTools(courseId) {
            if (this.user.hasAnyRole(['Owner', 'Admin', 'Instruction Admin'])) {
                return true;
            }

            if (this.user.isStudentOf(courseId)) {
                return false;
            }

            if (this.user.hasEnrolledPermissionTo('view all quizzes') && this.user.isInstructorOf(courseId)) {
                return true;
            }

            if (this.user.hasRoleWithinCourseGroup(courseId, 'Instructor')) {
                return this.user.hasGroupPermissionWithinCourse(courseId, 'view all quizzes');
            }

            return false;
        },

        redirectToAccessDenied() {
            this.$router.push(buildAccessDeniedLocation(this.$route));
        },
    },
};
